
import { defineComponent, onMounted, computed, ref } from "vue";
import { setCurrentPageBreadcrumbs } from "@/core/helpers/breadcrumb";
import FundingRounds from "@/components/widgets/lists/funding-rounds.vue";
import { useStore } from "vuex";
import { Actions } from "@/store/enums/StoreEnums";
import { useRoute } from "vue-router";

export default defineComponent({
  name: "business-details",
  components: {
    FundingRounds,
  },
  setup() {
    const store = useStore();
    const route = useRoute();
    const business = ref<Record<string, unknown>>({});
    const businesses = computed(() => store.getters.getBusinesses);
    const toUpperCase = (value) => {
      return value?.toUpperCase();
    };
    const parseJSON = (value) => {
      try {
        return value ? JSON.parse(value) : [];
      } catch (err) {
        return [];
      }
    };
    onMounted(async () => {
      if (!businesses.value?.founderBusinesses?.length) {
        try {
          const response = await store.dispatch(
            Actions.GET_FOUNDER_BUSINESSES,
            {
              page: 1,
              perPage: 10,
            }
          );
          if (response !== true) throw new Error();
          business.value = businesses.value?.founderBusinesses.find(
            (b) => b.id == route.params.id
          );
        } catch (err) {
          console.log(err);
        }
      } else
        business.value = businesses.value?.founderBusinesses.find(
          (b) => b.id == route.params.id
        );
      setCurrentPageBreadcrumbs("Business Details", ["Business"]);
    });
    return {
      business,
      toUpperCase,
      parseJSON,
      route,
    };
  },
});
